var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{attrs:{"id":"modal-zone-delete","title":"Delete cycle zone","visible":_vm.showModal},on:{"ok":_vm.handleOk,"hide":() => _vm.$emit('modalClose')}},[_vm._v(" delete zone "+_vm._s(_vm.zoneToDel?.name)+" ? ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }